export const GET_CAREERS = "GET_CAREERS";
export const ADD_REMARKS = "ADD_REMARKS";
